import { EntityDataStore, WorkflowSchema } from '@skinsoft/entity-data-store';
import { cloneDeep, set } from 'lodash';
import { first } from 'rxjs/operators';

interface DateContainer {
    startInterval: {
        date: Date;
    };
}

export enum TaskLifecycleStates {
    FINALIZED = 'finalized',
    IN_PREPARATION = 'inPreparation',
    IN_PROGRESS = 'inProgress',
    PLANNED = 'planned',
}

export interface Task {
    id: string;
    title: string;
    taskSchema: {
        applicant: string;
        demandDate: DateContainer;
        limitDate: DateContainer;
    };
    workflowSchema: WorkflowSchema<TaskLifecycleStates>;
}

export class TaskDataStore extends EntityDataStore<Task, TaskLifecycleStates> {
    public static highlightStates = [TaskLifecycleStates.PLANNED];
    public static featuredStates = [TaskLifecycleStates.IN_PROGRESS, TaskLifecycleStates.PLANNED]; // the order matters, it is used in the featured lists
    public static historyStates = [TaskLifecycleStates.FINALIZED];
    public static sortFields = ['taskSchema.demandDate.startInterval.date'];

    public static getInstance() {
        if (!TaskDataStore.instance) {
            TaskDataStore.instance = new TaskDataStore();
        }

        return TaskDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$taskDataStore = TaskDataStore.getInstance();
    }

    private static instance: TaskDataStore = null as any;

    constructor() {
        super('tasks');
    }

    public async updateOperatorComment(id: Task['id'], operatorComment: string, locale: string) {
        const task = await this.getTask(id);

        set(task, `taskSchema.operatorComment.translatedString.${locale}`, operatorComment);

        await this.update(task.id, task)
            .pipe(first())
            .toPromise();
    }

    private async getTask(id: Task['id']) {
        return cloneDeep(
            await this.fetchOne(id, true)
                .pipe(first())
                .toPromise(),
        );
    }
}
